import { saveAs } from 'file-saver';

export const save = (blob: any, filename: any) => {
  saveAs(blob, filename);
};
